import React, { useEffect, } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createUpdate, getUpdate, resetState, updateUpdate } from "../../Association/features/update/UpdateSlice";
import { toast } from "react-toastify";
import CustomInput from "../components/CustomInput";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

let schema = yup.object().shape({
  title: yup.string().required("Title is Required"),
  content: yup.string().required("content is Required"),


});

const AddMember = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsId = location.pathname.split("/")[3];
  const NewsState = useSelector((state) => state.update);
  const { isSuccess, isError, isLoading, createdUpdate, updatetitle, updatecontent, updatedUpdate } = NewsState;

  const token = useSelector((state) => state.autht.token);
  useEffect(() => {
    if (getNewsId !== undefined) {
      dispatch(getUpdate(getNewsId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsId, dispatch]);

  useEffect(() => {
    dispatch(resetState());

  }, [dispatch]);

  useEffect(() => {
    if (isSuccess && createdUpdate) {
      toast.success("Update Added Successfully!");
      dispatch(resetState());
    }
    if (isSuccess && updatedUpdate) {
      toast.success("Update Updated Successfully!");
      navigate("/association/Update-list");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {

      title: updatetitle || "",
      content: updatecontent || "",
      token: token

    },
    validationSchema: schema,
    onSubmit: (values) => {

      if (getNewsId !== undefined) {
        const data = { id: getNewsId, NewsData: values };
        dispatch(updateUpdate(data));
        dispatch(resetState());
      } else {
        dispatch(createUpdate(values));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });

  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image", "video"],
      ["clean"],
    ],
  };



  return (
    <div>
      <h3 className="mb-4 title">{getNewsId !== undefined ? "Edit" : "Add"} Updates</h3>

      <div className="">
        <form action="" onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter Title"
              name="title"
              onChng={formik.handleChange("title")}
              onBlr={formik.handleBlur("title")}
              val={formik.values.title}
            />
            <div className="error">{formik.touched.title && formik.errors.title}</div>
          </div>

          <ReactQuill
            theme="snow"
            className="mt-3"
            name="content"
            modules={modules}
            onChange={formik.handleChange("content")}
            value={formik.values.content}
          />
          <div className="error">{formik.touched.content && formik.errors.content}</div>




          <button className="btn btn-success border-0 rounded-3 my-5" type="submit">
            {getNewsId !== undefined ? "Edit" : "Add"} Updates
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddMember;